export default __webpack_public_path__ + "static/media/button_point-off.dc1e24f7.svg";